import { useMemo } from "react";

import { NestedValue } from "@intelligems/ig-types";
import { useDispatch, useSelector } from "@src/store";
import { UserInterfaceField } from "@src/store/slices/userInterfaces/types";
import { setWidgetConfig } from "@src/store/slices/widgets";
import { getProgressBarWidgetVariable } from "@src/store/slices/widgets/selectors";
import { WidgetConfigKey } from "@src/store/slices/widgets/types";

export function useShippingProgressBarConfig<T extends WidgetConfigKey>(
  path: T
) {
  const dispatch = useDispatch();

  const value = useSelector(getProgressBarWidgetVariable(path)) as NestedValue<
    WidgetConfigKey,
    T
  >;

  return useMemo(() => {
    const setValue = (value: NestedValue<WidgetConfigKey, T>) => {
      dispatch(
        setWidgetConfig({
          key: path,
          value,
        })
      );
    };
    return [value, setValue] as UserInterfaceField<
      NestedValue<WidgetConfigKey, T>
    >;
  }, [value, path]);
}
